<div class="meeting-minute-rows">

  @for (row of controls; track trackRow($index, row); let index = $index) {
    <div class="meeting-minute-row" [formGroup]="row">

      <div class="meeting-minute-row-header">
        <span class="meeting-minute-row-index">Next meeting {{ index + 1 }}</span>
        @if (!readonlyRows) {
          <button
            type="button"
            class="btn btn-outline-danger btn-icon remove-row-button"
            title="Remove next meeting"
            (click)="onRemoveRow(index)">
            <i class="fa fa-solid fa-trash"></i>
          </button>
        }
      </div>

      <div class="row">
        <div class="col-lg-6 col-md-12">
          <textarea-field
            label="Topics"
            placeholder="Topics of the next meeting"
            [textareaFormControl]="getControl(row, 'topics')"
            [readonly]="readonlyRows"
            [height]="100">
          </textarea-field>
        </div>

        <div class="col-lg-3 col-md-6">
          <input-field
            label="Date"
            [inputFormControl]="getControl(row, 'date')"
            [type]="'datetime-local'"
            [readonly]="readonlyRows">
          </input-field>
        </div>

        <div class="col-lg-3 col-md-6">
          <input-field
            label="Place"
            placeholder="Where"
            [inputFormControl]="getControl(row, 'place')"
            [type]="'text'"
            [readonly]="readonlyRows">
          </input-field>
        </div>
      </div>

    </div>
  } @empty {
    <div class="empty-text text-center text-muted py-3">
      @if (readonlyRows) {
        This meeting minute has no next meeting.
      } @else {
        No next meeting yet. Use "Add item" to create the first one.
      }
    </div>
  }

  @if (!readonlyRows) {
    <div class="add-row-bar">
      <button type="button" class="btn btn-primary" (click)="onAddRow()">
        <i class="fa fa-plus me-1"></i>Add item
      </button>
    </div>
  }

</div>
